<template>
  <div>
    <div v-show="loading" style="z-index:100; background-color: white; opacity:1; width:100%; height:2000px; overflow:hidden; text-align:center;">
        <p style="margin-top: 500px; z-index:1001; opacity:0.6;">
          <i class="fa fa-refresh fa-spin"></i>
        </p>
    </div>
    <div v-show="!loading" id="app" class="animated fadeIn fadeOut"  style="max-width: 55rem; background-color: rgba( 255, 255, 255, 1 ); margin:0px auto;">
      <!-- <div id="app_2">
        <StepProgress active-color="skyblue" :steps="steps['EN']" :current-step="status.step"/>
      </div> -->
      <div id="app1">
        <b-row class="text-center">
          <b-col class="mt-5">
            <h3 style="margin-top:10px; color:red;" id="doc_type">[CONFIDENTIALITY]</h3><br>
          </b-col>
        </b-row>
        <hr>
        <div class="mt-5 text-center">
          <div>
            <b-row style="padding-left:25px; padding-right:20px;" class="text-center">
              <b-col>
                <h1 style="color:#3D63BA;">
                  <b id="doc_report_short_title" v-if="is_f1security_slogan()">F1-UWSS</b>
                  <b id="doc_report_short_title" v-else>{{custom.slogan.toUpperCase()}}</b>
                  <b>
                    <span id="doc_report_full_title" v-if="is_wc && !is_wsf && !is_wmds && !is_wf" style="color:#829DD4;">WEBCastle</span>
                    <span id="doc_report_full_title" v-else-if="!is_wc && is_wsf && !is_wmds && !is_wf" style="color:#829DD4;">WSFinder</span>
                    <span id="doc_report_full_title" v-else-if="!is_wc && !is_wsf && is_wmds && !is_wf" style="color:#829DD4;">WMDS</span>
                    <span id="doc_report_full_title" v-else-if="!is_wc && !is_wsf && !is_wmds && is_wf" style="color:#829DD4;">WFDetector</span>
                    <span id="doc_report_full_title" v-else-if="!is_wc && !is_wsf && !is_wmds && !is_wf" style="color:#829DD4;">{{is_f1security_slogan() ? 'Unified Web Security Service' : ''}}</span>
                    <span id="doc_report_full_title" v-else style="color:#829DD4;">{{is_f1security_slogan() ? 'Unified Web Security Service' : ''}}</span>
                  </b>
                  <!-- <b>
                    <span id="doc_report_full_title" style="color:#829DD4;">{{is_f1security_slogan() || !custom.slogan ? ':Unified Web Security Service' : ''}}</span>
                  </b> -->
                  </h1>
                <h2 v-if="!is_report_custom" class="mt-1"><b id="doc_date_monthly">月次報告書</b></h2>
              </b-col>
            </b-row>
          </div>
        </div>
        <hr>
        <b-row class="mt-5 text-center">
          <b-col>
            <h4 class="pt-2"><b id="doc_username">{{auth.profile.username}}</b></h4>
          </b-col>
        </b-row>
        <hr>
        <b-row class="text-center mt-2">
        <!-- custom area -->
          <center style="width:100%;">
            <p>* This area does not display when exporting</p>
            <VueHotelDatepicker style="margin: 0 10px;" v-if="is_report_custom" block :format="'YYYY-MM-DD'" :minDate="minDate" :maxDate="maxDate" @confirm="confirm_custom"/>
            <v-select style="margin: 0 10px; width: 150px; display:inline-block;" v-if="!is_report_custom" :readonly="true" v-model="opt.year" :options="years" ></v-select>
            <span style="margin: 0 10px;" v-if="!is_report_custom">/</span>
            <v-select value="$store.myValue" @input="confirm_monthly" style="margin: 0 10px; width: 150px; display:inline-block;" v-if="!is_report_custom" :readonly="true" label="text" v-model="opt.month" :options="codes.REPORT_MONTH_ENG" ></v-select>
            <b-form-checkbox style="display:inline-block;" v-model="is_report_custom"> Select Date </b-form-checkbox>
            <b-btn style="margin:0 20px;" @click="makePDF()" variant="outline-success">Export PDF</b-btn>
            <hr style="width:50%;">
            <b-form-checkbox :disabled="!auth.license.WEBCastle.use" style="display:inline-block; padding-right:10px;" v-model="is_wc"> WEBCastle </b-form-checkbox>
            <b-form-checkbox :disabled="!auth.license.WSFinder.use" style="display:inline-block; padding-right:10px;" v-model="is_wsf"> WSFinder </b-form-checkbox>
            <b-form-checkbox :disabled="!auth.license.WMDS.use" style="display:inline-block; padding-right:10px;" v-model="is_wmds"> WMDS </b-form-checkbox>
            <b-form-checkbox :disabled="!auth.license.WFDetect.use" style="display:inline-block;" v-model="is_wf"> WFDetecter </b-form-checkbox>
            <b-btn style="margin:0 20px;" variant="outline-dark" @click="report()">Apply</b-btn>
          </center>
        </b-row>
        <!-- 도메인별 보고서용 -->
        <hr v-if="auth.license.WEBCastle.use && is_wc && !is_wsf && !is_wmds && !is_wf">
        <b-row class="text-center" v-if="auth.license.WEBCastle.use && is_wc && !is_wsf && !is_wmds && !is_wf">
          <b-col sm="2">
          </b-col>
          <b-col sm="4">
            <p>1. Server</p>
            <!-- @select="() => getDomainList()" -->
            <multiselect
              @input="getDomainList()"
              v-model="agent"
              tag-placeholder="Select Server"
              placeholder="Select Server"
              label="nickname"
              track-by="nickname"
              :options="agent_list"
              :multiple="true"
              :taggable="true"
              @tag="add_tag">
            </multiselect>
          </b-col>
          <b-col sm="4">
            <p>2. Domain</p>
            <multiselect
              @input="domain_reload()"
              @select="reload('domain')"
              v-model="domain"
              tag-placeholder="Select domain"
              placeholder="Select domain"
              :options="domain_list"
              :multiple="true"
              :taggable="true"
              :disabled="!agent.length || !domain_list.length || domain_loading"
              @tag="add_tag">
            </multiselect>
          </b-col>
        </b-row>
        <hr>
        <b-row class="justify-content-md-center mt-5">
          <b-col md="8">
            <Caution></Caution>
          </b-col>
        </b-row>
        <img style="opacity:0.8; width: 100%; margin-top:100px;" src="../../../assets/footer_onpremise.png"/>
      </div>
      <!-- 목차 부분 -->
      <div>
      <br>
        <Contents
          style="padding-left:20px;"
          :isWC="is_wc"
          :isWSF="is_wsf"
          :isWMDS="is_wmds"
          :isWF="is_wf"
          :wsfinder_list="wsfinder_summary"
          :castle_agent="castle_agent"
          :wf_daily_detect_domain="WF_Daily_detect_domain"
          :wf_daily_detect_server="WF_Daily_detect_server"
          :webcastle_list="{ daily : WebCastle_Daily_log_by_server, agent_info : WebCastle_total_info_by_server_2_2_3_1, domain_info : WebCastle_total_info_by_server_2_2_3_2, top_n_attack_domain : webcastle.top_n_attack_domain }"
          :WebCastle_Daily_log_by_domain="WebCastle_Daily_log_by_domain"
          :wmds_list="wmds_summary"
          :wc_list="{ agent : webcastle.agent_list, selected_agent : agent, domain : webcastle.domain_list, selected_domain : domain }"
          :show_agent="show_wc_agent()"
          :show_domain="show_wc_domain()"
          />

      </div>
      <hr>
      <div style="padding-left:20px; padding-right:20px;">
        <h3 style="color:#3D63BA"><b>1. 概況</b></h3><br>
        <b-row style="padding-left:25px;">
          <b-col>
            <h4><b>1.1 基本情報</b></h4>
            <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
              <tbody>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:40%">Username</th>
                  <th style="background-Color:#f0f3f5; text-align: center;">{{auth.profile.username}}</th>
                </tr>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Report period</th>
                  <th style="border-top:1px solid; background-Color:#f0f3f5; text-align: center;">{{from}} ~ {{to}}</th>
                </tr>
              </tbody>
            </table>
            <h4><b>1.2 サービスの契約内容</b></h4>
            <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
              <tbody>
                <tr style="height: 23px;">
                  <th class="table-f1" style="width: 40%" colspan="2">Registration/Update Date</th>
                  <th class="table-f1 border-bg-f1 border-text-f1">
                    <!-- {{wmds_summary && wmds_summary.general_information && wmds_summary.general_information.created_at | date}} / {{wmds_summary && wmds_summary.general_information && wmds_summary.general_information.last_visit | date}} -->
                    {{ SUMMARY.joined_at | date }} / {{ SUMMARY.updated_at | date }}
                  </th>
                </tr>
                <tr style="height: 24px;">
                  <th class="table-f1" style="width: 40%" colspan="2">Service Type</th>
                  <!-- <th class="table-f1 border-bg-f1 border-text-f1">{{auth.profile.service}}</th> -->
                  <th class="table-f1 border-bg-f1 border-text-f1">{{SUMMARY.service_name || '-'}}</th>
                </tr>
                <tr style="height: 24px;" v-for="service, index in SUMMARY.prev_subscription" v-bind:key="'service_type_' + index">
                  <th class="table-f1" style="width: 40%" colspan="2">Service Type</th>
                  <th class="table-f1 border-bg-f1 border-text-f1">{{service}}</th>
                </tr>
                <tr style="height: 23px;">
                  <th class="table-f1" style="width:10%" :rowspan="4">Protection Function</th>
                  <th class="table-f1">Web Hacking</th>
                  <th class="table-f1 border-bg-f1 border-text-f1">{{auth.profile.service == 'Pro' || 'Premium' || 'Basic' ? 'Include' : 'N/A'}}</th>
                </tr>
                <tr style="height: 20px;">
                  <th class="table-f1">WebShell</th>
                  <th class="table-f1 border-bg-f1 border-text-f1">{{auth.profile.service == 'Pro' || 'Premium' ? 'Include' : 'N/A'}}</th>
                </tr>
                <tr style="height: 23px;">
                  <th class="table-f1" >Web Malware Distribution</th>
                  <th class="table-f1 border-bg-f1 border-text-f1">{{auth.profile.service == 'Pro' || 'Premium' || 'Basic' ? 'Include' : 'N/A'}}</th>
                </tr>
                <tr style="height: 23px;">
                  <th class="table-f1">Web Forgery</th>
                  <th class="table-f1 border-bg-f1 border-text-f1">{{auth.profile.service == 'Pro' || 'Premium' || 'Basic' ? 'Include' : 'N/A'}}</th>
                </tr>
              </tbody>
            </table>
            <h4><b>1.3 サービスの使用状況</b></h4>
            <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
              <tbody>
                <tr style="height: 23px;">
                  <th  class="table-f1" style="width:10%"  :rowspan="4">Protection Function</th>
                  <th  class="table-f1" style="width:30%">Web Hacking</th>
                  <th  class="table-f1 border-bg-f1 border-text-f1">{{webcastle.agent_list && webcastle.agent_list.length > 0 ? 'Using ' + webcastle.agent_list_alive.length : 'N/A'}}</th>
                </tr>
                <tr style="height: 20px;">
                  <th  class="table-f1">WebShell</th>
                  <th  class="table-f1 border-bg-f1 border-text-f1">{{wsfinder_summary.wsf_status > 0 ? 'Using ' + wsfinder_summary.wsf_status : 'N/A'}}</th>
                </tr>
                <tr style="height: 23px;">
                  <th  class="table-f1">Web Malware Distribution</th>
                  <th  class="table-f1 border-bg-f1 border-text-f1">{{wmds_summary.wmds_status > 0 ? 'Using ' + wmds_summary.wmds_status : 'N/A'}}</th>
                </tr>
                <tr style="height: 23px;">
                  <th class="table-f1">Web Forgery</th>
                  <th class="table-f1 border-bg-f1 border-text-f1">
                    {{wmds_summary && wmds_summary.domain_and_wf_detector_status && wmds_summary.domain_and_wf_detector_status.length > 0 ? 'Using ' + wmds_summary.domain_and_wf_detector_status.length : 'N/A'}}
                  </th>
                </tr>
              </tbody>
            </table>
            <h4><b>1.4 サービスの構成状況</b></h4>
            <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
              <tbody>
                <tr>
                  <th class="table-f1" style="width:14%" :rowspan="dynamic_row_span">
                    <span style="font-size:0.9em;">Configuration <br> Status </span>
                  </th>
                  <th class="table-f1" rowspan="2">Service</th>
                  <th class="table-f1" rowspan="2">Name</th>
                  <th class="table-f1" colspan="7" style="width:200px;">Policy</th>

                </tr>
                <!-- WEBCastle  -->
                <tr>
                  <th class="table-f1" colspan="2">MODE</th>
                  <th class="table-f1" colspan="1">LEVEL</th>
                  <th class="table-f1" colspan="4">Domain</th>
                </tr>
                <tr v-if="webcastle.agent_list && webcastle.agent_list.length" v-for="(agent, index) in webcastle.summary_1_4" :key="'1_4_'+index">
                  <th
                    class="border-bg-f1"
                    v-if="index == 0"
                    :rowspan="webcastle.summary_1_4.length"
                  >
                    WEBCastle
                  </th>
                  <th class="border-bg-f1">
                    {{agent.name}}
                  </th>
                  <th class="border-bg-f1" colspan="2">
                    <b-badge v-if="agent.mode == 'On'" variant="danger">Block</b-badge>
                    <b-badge v-else-if="agent.mode == 'DetectionOnly'" variant="warning">DetectionOnly</b-badge>
                    <b-badge v-else variant="secondary">Off</b-badge>
                  </th>
                  <th class="border-bg-f1">
                    {{agent.level}}
                  </th>
                  <th class="border-bg-f1" colspan="4" style="max-width:10px; text-overflow: ellipsis;">
                    {{ agent.domain.trim() | truncate(30) }}
                  </th>
                </tr>
                <tr v-if="!(webcastle.agent_list && webcastle.agent_list.length)">
                  <th class="border-bg-f1">WEBCastle</th>
                  <th class="border-bg-f1">N/A</th>
                  <th class="border-bg-f1" colspan="2">N/A</th>
                  <th class="border-bg-f1" colspan="1">N/A</th>
                  <th class="border-bg-f1" colspan="4">N/A</th>
                </tr>

                <!-- WSFinder  -->
                <tr >
                  <th class="table-f1" style="padding:2px;" rowspan="2"> Service </th>
                  <th class="table-f1" style="padding:2px;" rowspan="2">Name</th>
                  <th class="table-f1" style="padding:2px 10px;" rowspan="2">RealTime <br> Mode</th>
                  <th class="table-f1" style="padding:2px 10px;" rowspan="2">Isolation <br> Mode</th>
                  <th class="table-f1" style="padding:2px;" colspan="5">Rule</th>
                </tr>
                <tr >
                  <th class="table-f1" style="padding:1px 5px;">Regex</th>
                  <th class="table-f1" style="padding:1px 5px;">Hash</th>
                  <th class="table-f1" style="padding:1px 5px;">URL</th>
                  <th class="table-f1" style="padding:1px 5px;">SSDEEP</th>
                  <th class="table-f1" style="padding:1px 5px;">Obfuscation</th>
                </tr>
                <tr  v-for="(WSF_1_5, index) in wsfinder_summary.web_security_configuration_status" :key="WSF_1_5.index">
                  <th
                    v-if="index == 0"
                    class="border-bg-f1"
                    :rowspan="wsfinder_summary.web_security_configuration_status.length"
                  >
                    WSFinder
                  </th>
                  <th class="border-bg-f1">{{WSF_1_5.host | truncate(20)}}</th>
                  <th class="border-bg-f1">
                    <b-badge style="font-size:0.9em" :variant="JSON.parse(WSF_1_5.setting).realtime_mode == true ? 'success' : 'light'">
                      {{JSON.parse(WSF_1_5.setting).realtime_mode ? 'On' : 'Off'}}
                    </b-badge>
                  </th>
                  <th class="border-bg-f1">
                    <b-badge style="font-size:0.9em" :variant="JSON.parse(WSF_1_5.setting).backup_mode == true ? 'success' : 'light'">
                      {{JSON.parse(WSF_1_5.setting).backup_mode ? 'On' : 'Off'}}
                    </b-badge>
                  </th>
                  <th class="border-bg-f1">
                    {{wsfinder_rule(WSF_1_5.setting).indexOf('regex') > -1 ? '&#10003;' : '-'}}
                  </th>
                  <th class="border-bg-f1">
                    {{wsfinder_rule(WSF_1_5.setting).indexOf('url') > -1 ? '&#10003;' : '-'}}
                  </th>
                  <th class="border-bg-f1">
                    {{wsfinder_rule(WSF_1_5.setting).indexOf('hash') > -1 ? '&#10003;' : '-'}}
                  </th>
                  <th class="border-bg-f1">
                    {{wsfinder_rule(WSF_1_5.setting).indexOf('ssdeep') > -1 ? '&#10003;' : '-'}}
                  </th>
                  <th class="border-bg-f1">
                    {{wsfinder_rule(WSF_1_5.setting).indexOf('ob') > -1 ? '&#10003;' : '-'}}
                  </th>
                </tr>
                <tr v-if="wsfinder_summary.web_security_configuration_status && wsfinder_summary.web_security_configuration_status.length < 1">
                  <th class="border-bg-f1">WSFinder</th>
                  <th class="border-bg-f1">N/A</th>
                  <th class="border-bg-f1">N/A</th>
                  <th class="border-bg-f1">N/A</th>
                  <th class="border-bg-f1">N/A</th>
                  <th class="border-bg-f1">N/A</th>
                  <th class="border-bg-f1">N/A</th>
                  <th class="border-bg-f1">N/A</th>
                  <th class="border-bg-f1">N/A</th>
                </tr>
                <tr >
                  <th class="table-f1">Service</th>
                  <th class="table-f1">Name</th>
                  <th class="table-f1" colspan="2">Schedule(Daily)</th>
                  <th class="table-f1" colspan="5">Policy</th>
                </tr>
                <!-- WMDS  -->
                <tr v-for="(WMDS_1_5, index) in wmds_summary.web_security_configuration_status" :key="WMDS_1_5.index">
                  <th
                    v-if="index == 0"
                    class="border-bg-f1"
                    :rowspan="wmds_summary.web_security_configuration_status.length"
                  >
                    WMDS
                  </th>
                  <th class="border-bg-f1">{{WMDS_1_5.name | truncate(20) }}</th>
                  <th style="border:1px solid; background-Color:#f0f3f5; text-align: left; padding-left:20px;" colspan="2">
                    <span v-for="(s, index) in (wmds_schedule(JSON.parse(WMDS_1_5.schedule)) || [])" v-bind:key="index" >
                      {{s}} <br>
                    </span>
                    <span v-show="!WMDS_1_5.name && wmds_schedule(JSON.parse(WMDS_1_5.schedule)).length < 1">N/A</span>
                  </th>
                  <th class="border-bg-f1" colspan="5">
                    {{!WMDS_1_5.name && !WMDS_1_5.description ? 'N/A' : (WMDS_1_5.description || '-')}}
                  </th>
                </tr>
                <tr v-if="wmds_summary.web_security_configuration_status && wmds_summary.web_security_configuration_status.length < 1">
                  <th class="border-bg-f1">WMDS</th>
                  <th class="border-bg-f1">N/A</th>
                  <th class="border-bg-f1" colSpan="2">N/A</th>
                  <th class="border-bg-f1" colspan="6">N/A</th>
                </tr>
              </tbody>
            </table>

            <!-- // TODO : 해당 데이터 준비되면 해야 함 -->
            <!-- <h4><b>1.5 Web Security Status</b></h4>
            <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
              <tbody>
                <tr>
                  <th style="border:1px solid; background-Color:#3D63BA; text-align: center; width: 40%"></th>
                  <th style="background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Risk</th>
                </tr>
                <tr>
                  <th class="table-f1" style="width: 40%">Web Hacking Attack Detection & Blocking</th>
                  <th class="border-bg-f1">{{`High`}} or {{`Medium`}} or {{`Low`}}</th>
                </tr>
                <tr>
                  <th class="table-f1" style="width: 40%">WebShell Detection & Response</th>
                  <th class="border-bg-f1">{{`High`}} or {{`Medium`}} or {{`Low`}}</th>
                </tr>
                <tr>
                  <th class="table-f1" style="width: 40%">Web Forgery Detection</th>
                  <th class="border-bg-f1">{{`High`}} or {{`Medium`}} or {{`Low`}}</th>
                </tr>
                <tr>
                  <th class="table-f1" style="width: 40%">Web Malware Distribution Detection</th>
                  <th class="border-bg-f1">{{`High`}} or {{`Medium`}} or {{`Low`}}</th>
                </tr>
              </tbody>
            </table> -->
          </b-col>
        </b-row>
        <hr v-show="is_wc">
        <ReportWebCastle
          :show_agent="show_wc_agent()"
          :show_domain="show_wc_domain()"
          :start="start_wc"
          v-show="is_wc"
          :from="from"
          :to="to"
          :castle_agent="castle_agent"
          :castle_summary="webcastle"
          :castle_recent="castle_recent"
          :WebCastle_attack_trend_total_2_3="WebCastle_attack_trend_total_2_3"
          :WebCastle_total_info_by_server_2_2_3_2="WebCastle_total_info_by_server_2_2_3_2"
          :WebCastle_total_info_by_server_2_2_3_1="WebCastle_total_info_by_server_2_2_3_1"
          :WebCastle_total_info_by_domain_2_2_4_1="WebCastle_total_info_by_domain_2_2_4_1"
          :WebCastle_Daily_log_by_server="WebCastle_Daily_log_by_server"
          :WebCastle_Daily_log_by_domain="WebCastle_Daily_log_by_domain"
          :WebCastle_Daily_Detecting="WebCastle_Daily_Detecting"
          :WebCastle_Daily_Blocking="WebCastle_Daily_Blocking"
        />
        <!-- WSFinder start  -->
        <hr v-show="is_wsf">
        <ReportWSFinder
          :is_only="!is_wc && !is_wmds && is_wsf && !is_wf"
          :start="start_wsf"
          v-show="is_wsf"
          :from="from"
          :to="to"
          :wsfinder_recent="wsfinder_recent"
          :wsfinder_summary="wsfinder_summary"
          :WSFinder_Daily_Detection_Total="WSFinder_Daily_Detection_Total"
          :WSFinder_Daily_Detection_Server="WSFinder_Daily_Detection_Server"
          :WSFinder_Daily_Pattern="WSFinder_Daily_Pattern"
        />
        <!-- wmds start -->
        <hr v-show="is_wmds">
        <ReportWMDS
          :is_only="!is_wc && is_wmds && !is_wsf && !is_wf"
          :start="start_wmds"
          v-show="is_wmds"
          :from="from"
          :to="to"
          :wmds_recent="wmds_recent"
          :wmds_summary="wmds_summary"
          :WMDS_Daily_Detecting_Total="WMDS_Daily_Detecting_Total"
          :WMDS_Daily_Detecting_Domain="WMDS_Daily_Detecting_Domain"
          :WMDS_Daily_Detecting="WMDS_Daily_Detecting"
          :WMDS_Daily_Pattern="WMDS_Daily_Pattern"
        />
        <!-- 위변조 시작 -->
        <hr v-show="is_wf">
        <ReportWFDetect
          :start="start_wf"
          v-show="is_wf"
          :from="from"
          :to="to"
          :wsfinder_summary="wsfinder_summary"
          :wmds_summary="wmds_summary"
          :WF_Daily_Detect_Total="WF_Daily_Detect_Total"
          :WF_Daily_detect_domain="WF_Daily_detect_domain"
          :WF_Daily_detect_server="WF_Daily_detect_server"
        />
        </b-row>
      </div>
      <hr>
      <div style="padding-left:20px;">
        <img v-if="!custom.image || (custom.slogan && custom.slogan.toUpperCase().indexOf('F1-UWSS') > -1)" style="width: 20%;" src="../../../assets/logo.png"/>
        <img v-else style="width: 20%;" :src="custom.image"/>
        <br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>
        <b-row class="justify-content-md-center">
          <b-col md="6">
            <h1 style="text-align: center; color:#3D63BA;"><b>{{custom.slogan ? custom.slogan.toUpperCase() : 'F1-UWSS'}}</b></h1>
            <hr>
            <h2 style="text-align: center; color:#829DD4;"><b>Service R&D Center</b></h2>
            <br><br>
            <h2 v-if="is_f1security_slogan()" style="text-align: center;"><b>テクニカルサポート</b></h2>
            <h3 v-if="is_f1security_slogan() && auth.profile.service == 'Premium'" style="text-align: center;">
              <b>
                <br>
                <span v-if="auth.profile.language == 'KR'"> Korea Tel: 02-6223-3544 </span>
                <span v-else> メール: +82-2-6223-3545 </span>
              </b>
            </h3>
            <h3 v-if="is_f1security_slogan()" style="text-align: center;">
              <!-- <b v-if="auth.profile.language == 'KR'">Korea E-mail: help@uwss.kr</b>
              <b v-else>メール: help@uwss.jp</b> -->
            </h3>
            <br><br><br><br><br><br><br>
            <h2 :style="`text-align: center; color:#829DD4;${custom.slogan && custom.slogan.toUpperCase().indexOf('UWSS') > -1 ? '' : ''}`"><b>End Of Document</b></h2>
          </b-col>
        </b-row>

        <br><br><br><br><br><br>
      </div>
        <!-- <img style="width: 100%;" src="../../../assets/footer_onpremise.png"/> -->
    </div>
</div>
</template>
<style>
  .table-f1 {
    border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; padding: 0px 5px;
  }
  .border-bg-f1 {
    border:1px solid; background-Color:#f0f3f5; color:#000000;  text-align: center;
  }
  .border-f1 {
    border:1px solid; color:#000000;  text-align: center;
  }
  .border-text-f1 {
    border:1px solid; text-align: center !important;
  }
</style>
<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>
